<template>
  <layout page="class-list">
    <page-title icon="lni lni-school-bench-alt" :breadcrumb="breadcrumb">Turmas</page-title>
    <div class="card table">
      <header class="card-header">
        <p class="card-header-title">
          <span>Turmas</span>
        </p>
        <div class="card-header-icon" aria-label="nova turma">
          <router-link class="button is-primary" to="/admin/turmas/nova">
            <i class="lni lni-plus mr-1"></i> <span>Nova Turma</span>
          </router-link>
        </div>
      </header>
      <div class="card-content">
        <div v-if="classes.length > 0" class="table-container">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Nome</th>
                <td class="has-text-right">Ações</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(_class, index) in classes" :key="_class.id">
                <td>{{ _class.name }}</td>
                <td class="has-text-right">
                  <router-link class="button is-primary is-small mr-1" :to="`/admin/turmas/${_class.id}/editar`" title="Editar Turma">
                    <i class="lni lni-pencil-alt"></i>
                  </router-link>
                  <button class="button is-danger is-small" title="Excluir Turma" @click="excluir(index, _class.id, _class.name)">
                    <i class="lni lni-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <empty-list v-else entity="turma" />
      </div>
    </div>
  </layout>
</template>

<script>
import api from '@/api'
import Swal from 'sweetalert2'
import { DASHBOARD, CLASS_LIST } from '@/config/breadcrumb/admin'
import Layout from '@/layout/admin/Layout'
import PageTitle from '@/components/admin/PageTitle'
import EmptyList from '@/components/ui/EmptyList'

export default {
  name: 'ClassList',
  components: {
    Layout,
    PageTitle,
    EmptyList
  },
  created () {
    api.get('classes').then(res => {
      this.classes = res.data
    })
  },
  data () {
    return {
      classes: []
    }
  },
  computed: {
    breadcrumb () {
      return [
        DASHBOARD,
        { ...CLASS_LIST, isActive: true }
      ]
    }
  },
  methods: {
    excluir (index, id, name) {
      Swal.fire({
        title: 'Tem certeza?',
        text: `Você tem certeza que deseja excluir a turma: ${name}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.isConfirmed) {
          api.delete(`/classes/${id}`).then(res => {
            if (res.status === 200) {
              this.classes.splice(index, 1)
            }
          })
        }
      })
    }
  }
}
</script>
